module.exports = __webpack_public_path__ + "img/lucky_460.06066f40.png";